import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Collapse, IconButton, Table, TableContainer, TableBody, TableHead, TableCell, TableRow } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { isNullish, getCardTypeIcon, dateFormat } from "utils/utils";
import s from "./PaymentDataTable.module.scss";

const PAGE_LOCALE_KEY = "page.internalReports.abnormality.payment.";

const AbnormalPaymentData = (props) => {
  const { t } = useTranslation();
  const { records } = props;
  const [expandedRow, setExpandedRow] = useState(null);
  console.log("records: ", records);

  if (!records || records.length === 0) {
    return;
  }
  const getPaymentDetail = (cardType) => {
    if (!isNullish(cardType)) return String(cardType);
    else return "-";
  };

  const getCardIconComponent = (cardType) => {
    const safeCardType = getPaymentDetail(cardType);
    const cardIcon = getCardTypeIcon(safeCardType);
    return cardIcon ? (
      <div>
        <img
          src={cardIcon}
          style={{ verticialAlign: "bottom" }}
          height={24}
          alt={cardType.toUpperCase}
        />
      </div>
    ) : (
      "-"
    );
  };

  const ExpandableRow = (props) => {
    const { row, rowIndex, expanded, onExpand } = props;

    const renderTransaction = (transactionList) => {
      // console.log(transactionList);
      let listObj;
      try {
        listObj = JSON.parse(transactionList);
      } catch {
        console.log("Parse transaction list object error");
        return;
      }

      if (!listObj || listObj.length === 0) {
        return;
      }

      return (
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Transaction ID</TableCell>
                <TableCell>Transaction Type</TableCell>
                <TableCell>Transaction Amount</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {listObj.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell>{row?.transactionId}</TableCell>
                  <TableCell>{row?.transactionType}</TableCell>
                  <TableCell>{row?.transactionAmount}</TableCell>
                  <TableCell>{row?.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      );
    };

    return (
      <>
        <TableRow className={expanded ? s.expandedRow : s.collapsedRow}>
          <TableCell>{row?.paymentId ?? row?.orderId}</TableCell>
          <TableCell>{row?.merchantId}</TableCell>
          <TableCell>
            {row?.createdAt ? dateFormat(row?.createdAt) : "-"}
          </TableCell>
          <TableCell>{getCardIconComponent(row?.cardType)}</TableCell>
          <TableCell>{row?.paymentGateway}</TableCell>
          <TableCell>{row?.netAmount}</TableCell>
          <TableCell>{row?.paymentStatus ?? row?.orderStatus}</TableCell>
          <TableCell>{row?.lastTransactionStatus}</TableCell>
          <TableCell>
            {row?.transactionList ? (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => {
                  onExpand(expanded ? null : rowIndex);
                }}
              >
                {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            ) : (
              "-"
            )}
          </TableCell>
        </TableRow>
        <TableRow className={s.txnSection}>
          <TableCell style={{ padding: 0 }} colSpan={12}>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              {renderTransaction(row?.transactionList)}
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const renderPaymentTable = (records) => {
    return (
      <TableContainer>
        <Table className={s.dataTable}>
          <TableHead>
            <TableRow>
              <TableCell>
                {t(PAGE_LOCALE_KEY + "paymentTable.column.title.id")}
              </TableCell>
              <TableCell>
                {t(PAGE_LOCALE_KEY + "paymentTable.column.title.merchantId")}
              </TableCell>
              <TableCell>
                {t(PAGE_LOCALE_KEY + "paymentTable.column.title.createdAt")}
              </TableCell>
              <TableCell>
                {t(PAGE_LOCALE_KEY + "paymentTable.column.title.cardType")}
              </TableCell>
              <TableCell>
                {t(
                  PAGE_LOCALE_KEY + "paymentTable.column.title.paymentGateway",
                )}
              </TableCell>
              <TableCell>
                {t(PAGE_LOCALE_KEY + "paymentTable.column.title.netAmount")}
              </TableCell>
              <TableCell>
                {t(PAGE_LOCALE_KEY + "paymentTable.column.title.paymentStatus")}
              </TableCell>
              <TableCell>
                {t(
                  PAGE_LOCALE_KEY +
                    "paymentTable.column.title.lastTransactionStatus",
                )}
              </TableCell>
              <TableCell>
                {t(
                  PAGE_LOCALE_KEY +
                    "paymentTable.column.title.transactionHistory",
                )}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody className={expandedRow !== null ? s.hasExpanded : ""}>
            {records.map((row, rowIndex) => {
              return (
                <ExpandableRow
                  row={row}
                  rowIndex={rowIndex}
                  expanded={expandedRow === rowIndex}
                  key={rowIndex}
                  onExpand={setExpandedRow}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return <>{renderPaymentTable(records)}</>;
};

export default React.memo(AbnormalPaymentData);
